export default "/USDC.e023e7a252cdf103bb28d866b0a5aeeb.svg";